import { useIntl } from 'react-intl';

import { EM_DASH } from '~/common/constants/unicode';
import { Box } from '~/eds/src/components/Box/Box';
import { NumberInput } from '~/eds/src/components/NumberInput/NumberInput';
import { useFormatNumber } from '~/i18n/hooks/useFormatNumber/useFormatNumber';

import { coerceInputValueToNumber, getSingleFieldValue } from '../../helpers';
import { BaseFieldProps } from './fieldTypes';

export const NumberField = ({
  field,
  editMode,
  editData,
  onEditDataChange,
  isWssField,
}: BaseFieldProps) => {
  const intl = useIntl();
  const formatNumber = useFormatNumber();
  const presentValue = editData[field.id];

  if (editMode) {
    return (
      <Box flex="1">
        <NumberInput
          name={field.name}
          aria-label={field.name}
          value={coerceInputValueToNumber(presentValue)}
          onChange={(updatedValue: number | string | null) =>
            onEditDataChange(field.id, coerceInputValueToNumber(updatedValue))
          }
          disabled={!field.is_editable || isWssField(field)}
          placeholder={intl.formatMessage({
            id: 'DocumentOverviewPanel.enterAmount',
            defaultMessage: 'enter amount',
            description: 'Placeholder text for number input field',
          })}
        />
      </Box>
    );
  }

  const singleValue = getSingleFieldValue(field.value);

  if (!singleValue || singleValue.value == null) {
    return EM_DASH;
  }

  const numericValue = parseFloat(singleValue.value.toString());

  if (isNaN(numericValue)) {
    return EM_DASH;
  }

  return <data value={singleValue.value}>{formatNumber(numericValue)}</data>;
};
